import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';

import { SupportBadge } from 'lib/components';
import { isEnvDevelopment } from 'lib/config';
import {
  AnnotationsContextProvider,
  GlobalContextProvider,
  VideoReactionContextProvider,
  VideoRequestContextProvider,
  VideosContextProvider,
} from 'lib/context';
import { useCookies } from 'react-cookie';
import 'react-toastify/dist/ReactToastify.css';
import { ActionDispatchProvider } from '../lib/ActionDispatchContext';
import { PageContextProvider } from './PageContext';

import { getSmsMessages } from 'lib/api';
import { useAuth } from 'lib/context/auth';
import { calculateRange } from 'lib/utils/functions';
import { countMessageNotifications } from 'lib/utils/messageNotifications';
import { useQuery } from 'react-query';
import { initFacebookSdk } from './pages/account/facebook/service/facebookInit';
import { MainRoutes } from './routes/main';

export const App = () => {
  const { userData, whitelabel } = useAuth();
  const [cookies] = useCookies();

  const [count, setCount] = React.useState(null);

  const isUpgrade = window.location.pathname.includes('/upgrade');
  const isSignUp = window.location.pathname.includes('/signup');
  const isResetPassword = window.location.pathname.includes(
    'verify-reset-password'
  );
  const packageDetailsExist = userData?.user?.packageDetails;

  //remove this after we remove sms conversations v1
  const dateObj = calculateRange('7d');

  useQuery(
    ['messages', '', '7d'],
    () =>
      getSmsMessages({
        search: '',
        size: 100,
        from: dateObj.from,
        ...(userData.isCompanyAdmin ? {} : { userId: userData.userId }),
      }),
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      enabled: !!userData.userId,
      onSuccess: res => {
        const unreadMessagesCount = countMessageNotifications(
          res?.chats || [],
          userData.userId
        );
        setCount(unreadMessagesCount);
      },
    }
  );

  if (!cookies.jwt && !isEnvDevelopment && !(isSignUp || isResetPassword)) {
    window.location.href = `https://${whitelabel.domainV2}/backoffice/incs/logout.php`;
  }

  // from AuthorizationContext
  if (!packageDetailsExist && !isSignUp && !isResetPassword) {
    window.location.href = `https://${whitelabel.domainV2}/backoffice/incs/logout.php`;
    return <></>;
  }

  if (!userData.verified && !isUpgrade && !(isSignUp || isResetPassword)) {
    window.location.href = '/upgrade';
  }

  initFacebookSdk();
  return (
    <>
      <link
        key={whitelabel.name}
        type='text/css'
        rel='stylesheet'
        href={
          'https://' +
          whitelabel.domainV2 +
          whitelabel.contentPath +
          '/css/style.css'
        }
      />
      <VideosContextProvider>
        <VideoRequestContextProvider>
          <ActionDispatchProvider>
            <GlobalContextProvider
              whitelabel={whitelabel}
              unreadMessagesCount={count}
            >
              <PageContextProvider>
                <VideoReactionContextProvider>
                  <AnnotationsContextProvider>
                    <BrowserRouter>
                      <MainRoutes />
                      {!isSignUp && <SupportBadge />}
                    </BrowserRouter>
                  </AnnotationsContextProvider>
                </VideoReactionContextProvider>
              </PageContextProvider>
            </GlobalContextProvider>
          </ActionDispatchProvider>
        </VideoRequestContextProvider>
      </VideosContextProvider>
    </>
  );
};
